import { motion } from 'framer-motion';
import styled from 'styled-components';
import { setVh } from 'utils/styles/mixins';
import { colors, layout } from 'utils/styles/theme';

import BgImage from 'assets/img/overlay-background.png';
import BgImageMob from 'assets/img/overlay-background-mobile.png';
import { mediaMobile } from 'utils/styles/responsive';
import { ButtonWrapper } from 'components/ButtonCta/ButtonCta.styles';

export const Wrapper = styled(motion.div)`
    width: 100%;
    height: ${setVh(100)};
    overflow: hidden;
    z-index: ${layout.zIndex.modals + 1};
    position: fixed;
    background-image: url(${BgImage});
    background-position: 50% 50%;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    
    ${mediaMobile(`
        background-image: url(${BgImageMob});        
    `)}
`;

export const CloseWrapper = styled(motion.div)`
    width: 60rem;
    height: 60rem;
    overflow: hidden;
    position: fixed;
    top: 64rem;
    right: 84rem;
    cursor: pointer;

    ${mediaMobile(`
        top: 61rem;
        right: 50%; 
        transform: translateX(50%);
    `)}
`;

export const Content = styled(motion.div)`
    width: 644rem;
    transform: scale(1.5);

    ${mediaMobile(`
        width: 90vw;
        margin-top: 100rem;
        transform: scale(1);
    `)}
`;

export const ContentHeader = styled(motion.div)`
    width: 100%;
    color: ${colors.white};
    font-family: FontLight;
    font-size: 24rem;
    letter-spacing: 2.88rem;
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    ${mediaMobile(`
        font-size: 16rem;
    `)}

    > span {
        width: auto;
        text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
    }
`;

export const ContentTitle = styled(motion.h4)`
    width: 100%;
    color: ${colors.white};
    font-family: FontRegular;
    font-size: 48rem;
    letter-spacing: 2.88rem;
    text-transform: uppercase;
    text-align: center;
    margin-top: 29rem;
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
    
    ${mediaMobile(`
        margin-top: 16rem;
        font-size: 42rem;
    `)}
`;

export const ContentSubtitle = styled(motion.div)`
    width: 100%;
    color: ${colors.white};
    font-family: FontRegular;
    margin: 17rem auto 80rem auto;
    display: flex;
    width: 100%;
    align-items: center;
    gap: 20rem;
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);

    ${mediaMobile(`
        margin: 17rem auto 36rem auto;
    `)}
`;
export const ContentSubtitleLeft = styled(motion.div)`
    font-family: FontRegular;
    font-size: 30rem;
    letter-spacing: 2.88rem;
    text-transform: uppercase;
    text-align: left;
    white-space: nowrap;    
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
    
    ${mediaMobile(`
        font-size: 10rem;
    `)}
`;
export const ContentSubtitleRight = styled(motion.div)`
    width: 100%;
    color: ${colors.white};
    font-family: FontLight;
    font-size: 16rem;
    text-align: left;
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
    
    ${mediaMobile(`
        font-size: 10rem;
    `)}
`;

export const ContentSubtitleDivide = styled.div`
    width: 1px;
    height: 62rem;
    background: ${colors.white};
    margin: 0 20rem;
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);

     ${mediaMobile(`
        margin: 0 5rem;
    `)}
`;

export const CtaWrapper = styled(motion.div)`
    width: 100%;
    height: 60rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: 36rem;

    ${ButtonWrapper} {
        width: 240rem;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        ${mediaMobile(`        
            width: 160rem;
        `)}
    }

`;
